const DefaultData = {
  APISERVERURL: "https://zotraiapi.azurewebsites.net/api/",
  APILOCALURL: "http://localhost:5126/api/",
  APIACTIVEURL: "https://zotraiapi.azurewebsites.net/api/",
  TENANTID: "zotrai",
  DEFAULTCOMPANYID: "D19EB72E-9995-4380-8E23-6A6E5316E035",
  DEFAULTBRANCHID: "bafb8c8c-706d-4c51-8dc3-de716b17de5a",
  APIACTIVEURL: "https://zotraiapi.azurewebsites.net/api/",
  TENANTID: "zotrai",
  DEFAULTCOMPANYID: "D19EB72E-9995-4380-8E23-6A6E5316E035",
  DEFAULTBRANCHID: "bafb8c8c-706d-4c51-8dc3-de716b17de5a",
  DEFAULTCURRENCY: "INR",
  DEFAULTRKEY:"rzp_live_T9M3rKuoG0vzh7",
  APPLICATIONTYPE: "PRODUCTION",
  WEBSITE: "https://zotrai.com",
  DEFAULTCOMPANYEMAIL: "support@zotrai.com",
  DEFAULTCOMPANYPHONENUMBER: "7842035522",
  DEFAULTCOMPANYGST: "36ANVPM2246A1Z0",
  DEFAULTCOMPANYNAME: "SAAR DEVELOPERS CODE PVT LTD",
  DEFAULTBRANDNAME: "ZOTRAI",
  DEFAULTCOMPANYADDRESS: "HYDERABAD, TELANGANA",
  FACEBOOKURL: "https://www.facebook.com/zotraiapp",
  TWITTERURL: "https://x.com/zotraiapp",
  INSTGRAMURL: "https://www.instagram.com/zotraiapp",
  THEMECOLOR1: "#244892",
  THEMECOLOR2: "#1a1a1a",
  THEMECOLOR3: "#ffffff",
  THEMECOLOR4: "#000000",
  THEMECOLOR5: "#84804B",
  LANDINGPAGETITLE: "AI-Powered Travel CRM for the Next Generation of Agents",
  LANDINGPAGESUBTITLE: "Automate, analyze, and scale your travel business with intelligent technology.",
  B2BWEBSITE: "https://b2b.zotrai.com/",
  FOOTERCOPYRIGHTS: "2010 - 2026 SAAR DEVELOPERS CODE PVT LTD.",
  FOOTERSUBTITLE:
    "Zotrai is our flagship SaaS travel portal designed for travel agencies, tour operators, and DMCs worldwide. Zotrai helps agencies manage everything in one place",
  COMPANYTYPE: "CLIENT",
  USERTYPE: "CLIENT",
  PLANTYPE: "TRIAL",
  DOMESTICFLIGHTFEE: "75",
  INTERNATIONALFLIGHTFEE: "300",
  DOMESTICHOTELBOOKINGFEE: "300",
  INTERNATIONALHOTELBOOKINGFEE: "500",
  BUSBOOKINGFEE: "50",
  PaymentGatewayFee: "2",
  DOMESTICFLIGHTFEE: "75",
  INTERNATIONALFLIGHTFEE: "300",
  DOMESTICHOTELBOOKINGFEE: "300",
  INTERNATIONALHOTELBOOKINGFEE: "500",
  BUSBOOKINGFEE: "50",
  PaymentGatewayFee: "2",
};

export default DefaultData;